module.exports = __webpack_public_path__ + "img/delicity_bag.c4302ef3.svg";